export default "__VITE_ASSET__D1A5d694__"